export default __webpack_public_path__ + "static/media/QTF_logo.947200c6.png";